import {useUserContext} from 'authentication/UserContext';
import {
	IMessageBarStyles,
	MessageBarCompat as FluentMessageBar,
	useTheme,
} from 'components/FluentUICompat';
import React from 'react';
import {useTranslation} from 'react-i18next';

type Props = {
	onHeightChange: (height: number) => void;
};

export const MessageBar: React.FC<Props> = ({onHeightChange}: Props) => {
	const {t} = useTranslation('appShell/layout', {keyPrefix: 'Layout'});
	const {isAvk, isBav} = useUserContext();
	const theme = useTheme();
	const containerRef = React.useRef<HTMLDivElement>(null);
	const isVisible = Boolean(isAvk || isBav);

	const messageBarStyles: IMessageBarStyles = React.useMemo(
		() => ({
			root: {backgroundColor: theme.palette.yellow},
			icon: {color: theme.palette.neutralPrimary},
			text: {color: theme.palette.neutralPrimary},
		}),
		[theme],
	);

	React.useEffect(() => {
		const element = containerRef.current;
		if (!isVisible || !element) {
			onHeightChange(0);
			return;
		}

		const reportHeight = () => onHeightChange(element.offsetHeight);
		reportHeight();

		if (typeof ResizeObserver === 'undefined') {
			return;
		}

		const observer = new ResizeObserver(reportHeight);
		observer.observe(element);

		return () => observer.disconnect();
	}, [isVisible, onHeightChange]);

	if (!isVisible) {
		return null;
	}

	const strMessageHTML = t('PreliminaryDataMessage');

	return (
		<div ref={containerRef} data-testid='message-bar'>
			<FluentMessageBar isMultiline={true} styles={messageBarStyles}>
				<div dangerouslySetInnerHTML={{__html: strMessageHTML}} />
			</FluentMessageBar>
		</div>
	);
};

export default MessageBar;
